import React from "react";
import { RouteObject } from "../../interfaces/navigation";

const EntryPoint = React.lazy(() => import("../../containers/ManualSale/EntryPointContainer"));

export const manualSaleRoutes: RouteObject[] = [
    {
        title: "manualSale",
        path: "/venta-manual",
        component: <EntryPoint />,
        protected: true
    }
];
